<template>
  <div class="columns is-multiline is-mobile is-variable is-3-desktop is-2-mobile">
    <search-artist-list-item
      v-for="artist in artists"
      v-bind:key="artist.id"
      v-bind:artist="artist"
    ></search-artist-list-item>
  </div>
</template>

<script>
  import SearchArtistListItem from '@/components/SearchArtistListItem'

  export default {
    name: 'SearchArtistList',
    components: {
      SearchArtistListItem
    },
    props: {
      artists: {
        type: Array,
        required: true
      }
    }
  }
</script>
